// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-phone-numbers__add-phone{display:flex;align-items:center}.edit-phone-numbers__add-phone a{flex:0 1 auto}.edit-phone-numbers .profile-phone:last-child{margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
